import "core-js/modules/es6.typed.uint32-array";
import "core-js/modules/es6.typed.uint16-array";
import "core-js/modules/es6.typed.uint8-array";
export function array8(n) {
  return new Uint8Array(n);
}
export function array16(n) {
  return new Uint16Array(n);
}
export function array32(n) {
  return new Uint32Array(n);
}